import React, { ReactNode } from 'react';
import {
  FormInput,
  Label,
  IFormInputProps,
  PatternFormatNumberInput,
  PatternFormatNumberInputProps,
} from '@grubhubprod/gh-cookbook-react';
import { Control, RegisterOptions, useController } from 'react-hook-form';

interface CookbookPatternFormatNumberInputWrapperBaseProps {
  name: string;
  control: Control;
  rules?: RegisterOptions;
  error?: IFormInputProps['error'];
  label?: ReactNode;
}

export type CookbookPatternFormatNumberInputWrapperProps =
  CookbookPatternFormatNumberInputWrapperBaseProps &
    PatternFormatNumberInputProps;

export function CookbookPatternFormatNumberInputWrapper({
  name,
  control,
  rules = {},
  error,
  label = '',
  ...cookbookPatternFormatNumberInput
}: CookbookPatternFormatNumberInputWrapperProps): JSX.Element {
  const {
    field: { ref, value, onBlur, onChange },
  } = useController({
    name,
    rules,
    control,
    defaultValue: control.defaultValuesRef.current[name] ?? '',
  });
  return (
    <FormInput
      error={error}
      inputSize={cookbookPatternFormatNumberInput.inputSize}
      blockWidth={cookbookPatternFormatNumberInput.blockWidth}
    >
      {label && (
        <Label htmlFor={cookbookPatternFormatNumberInput.id}>{label}</Label>
      )}
      <PatternFormatNumberInput
        {...cookbookPatternFormatNumberInput}
        inputRef={ref}
        value={value}
        onValueChange={onChange}
        onBlur={onBlur}
      />
    </FormInput>
  );
}
